import clsx from 'clsx'
import {FC, PropsWithChildren, useMemo} from 'react'
import {HeaderProps} from 'react-table'
import {idvResponse} from '../../core/_models'

import {verificationRequestConstants} from '../../../../../../../data/redux/ninVerification/reducer'
import {useDispatch, useSelector} from "react-redux";
import {orderBy, partition, get, isNil, isEmpty} from "lodash";
import {IPersonProfile} from "../../../interfaces/IPersonProfile";
import { IVerification } from '../../../interfaces/IVerification'

type Props = {
  className?: string
  title?: string
  tableProps: PropsWithChildren<HeaderProps<IVerification>>
}
const PersonKycCustomHeader: FC<Props> = ({className, title, tableProps}) => {
  const dispatch = useDispatch()
  const {id} = tableProps.column
  const {data, sorting} = useSelector((state: any) => state.verificationRequests)

  const isSelectedForSorting = useMemo(() => {
    return sorting.column && sorting.column === id
}, [sorting, id])

const sortColumn = () => {

    // avoid sorting for these columns
    if (id === 'actions' || id === 'selection') {
        return
    }

    const currentOrder = sorting.order
    const order = currentOrder === 'desc' ? 'asc' : 'desc'

    // deep copy the data since you can not mutate the state directly
    const rawData = [...data]

    // partition the data into sortable and unsortable (null column)
    const [unsortable, sortable] = partition(rawData, q => isNil(get(q, id)) || isEmpty(get(q, id)))
    // console.log(sortable);

    let sortedData: any

    sortedData = orderBy(sortable, id, order).concat(unsortable)

    if(id === 'metaData.matchingStatus'){  //### REFACTOR find out how to pass booleans through the partition function above
      sortedData = orderBy(unsortable, id, order)
    }

    dispatch({
        type: verificationRequestConstants.SET_SORT_PARAMS,
        payload: {
            data: sortedData,
            sorting: {
                column: id,
                order: order
            }
        }
    })
  }

  return (
    <th
      {...tableProps.column.getHeaderProps()}
      className={clsx(
        className,
        isSelectedForSorting && sorting.order !== undefined && `table-sort-${sorting.order}`
      )}
      // style={{cursor: 'pointer'}}
      // onClick={sortColumn}
    >
      {title}
    </th>
  )
}

export {PersonKycCustomHeader}
